/**
 * text-utils.ts
 *
 * Shared text transformation helpers for display-only formatting.
 * Raw values stored in the database are never transformed here —
 * these functions are for rendering only.
 */

/**
 * Converts a string to Title Case for display purposes.
 * Words that are all-caps (acronyms) are left unchanged.
 * Examples:
 *   "acme international" → "Acme International"
 *   "IBM solutions" → "IBM Solutions"
 */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str
    .split(/\s+/)
    .map((word) => {
      // Leave all-caps words (acronyms) unchanged
      if (word === word.toUpperCase() && word.length > 1) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
